// How a resume's look settings turn into sizes. Shared by the preview on screen and the page
// that is printed, so they cannot drift apart. Sizes are px at 96 dpi on an A4 sheet.
export const PAGE_WIDTH = 794
export const PAGE_HEIGHT = 1123

export const FONTS = {
  sans: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Helvetica, Arial, sans-serif',
  serif: 'Georgia, "Times New Roman", Times, serif',
  mono: 'ui-monospace, "SF Mono", Menlo, Consolas, monospace',
}
export const FONT_SIZES = { small: 12, medium: 13.5, large: 15 }
export const GAPS = { compact: 12, normal: 18, relaxed: 26 }
export const PADDING = { compact: 40, normal: 48, relaxed: 56 }

export const gapOf = (settings) => GAPS[settings.spacing] || GAPS.normal
export const paddingOf = (settings) => PADDING[settings.spacing] || PADDING.normal

export const typography = (settings) => ({
  fontFamily: FONTS[settings.font] || FONTS.sans,
  fontSize: `${FONT_SIZES[settings.font_size] || FONT_SIZES.medium}px`,
  lineHeight: 1.45,
})

// Which layout draws each template. Several templates share one and differ in their styles.
export const FAMILY = {
  modern: 'single', classic: 'single', minimal: 'single', harvard: 'single', compact: 'single', executive: 'single', timeline: 'single',
  europass: 'label', lebenslauf: 'label',
  sidebar: 'side', twocolumn: 'side',
}

// Templates with a coloured column run to the edge of the page, so the sheet has no side padding.
export const isBleed = (template) => FAMILY[template] === 'side'
export const horizontalPaddingOf = (template, settings) => (isBleed(template) ? 0 : paddingOf(settings))

export const SIDEBAR_WIDTH = 32 // percent
export const SIDEBAR_LIGHT = '#f3f4f6'

// The text colour that reads on a background (white on dark, near black on light).
export function readableOn(hex) {
  const value = /^#[0-9a-f]{6}$/i.test(hex) ? hex : '#2563eb'
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(value.slice(i, i + 2), 16))
  return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? '#111827' : '#ffffff'
}

// Where the sidebar sits, and its colour: the accent (dark look) or a light grey. Drawn as the
// sheet's own background so it runs the full height of every page.
export function sidebarOf(template, settings) {
  if (!isBleed(template)) return null
  const left = template === 'sidebar'
  const background = left ? settings.accent : SIDEBAR_LIGHT
  return { left, background, color: left ? readableOn(settings.accent) : '#1f2937' }
}

export function sheetBackground(template, settings) {
  const side = sidebarOf(template, settings)
  if (!side) return {}
  return { backgroundImage: `linear-gradient(to ${side.left ? 'right' : 'left'}, ${side.background} 0 ${SIDEBAR_WIDTH}%, transparent ${SIDEBAR_WIDTH}%)` }
}
